import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";

const page = usePage()

const version = computed<string>(() => {
    return page.props.version as string
})

export const useVersion = () => {
    return {
        version,
    }
}
